module.exports = __webpack_public_path__ + "static/img/icon_search_clear_mo.2dbae7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_search_clear_mo.svg
// module id = BQFU
// module chunks = 10